module.exports = __webpack_public_path__ + "media/images/doc-thumb-1-ae70f505a7cfa20947f500559eedaa91.jpg";